export default __webpack_public_path__ + "static/media/logob.ba510f00.png";